import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

export function Pagination({ skip, limit, total, onPageChange }) {
  const currentPage = Math.floor(skip / limit) + 1;
  const totalPages = Math.max(1, Math.ceil(total / limit));

  if (totalPages <= 1) return null;

  return (
    <div className="flex items-center justify-between px-5 py-3 border-t border-zinc-200" data-testid="pagination">
      <p className="text-xs text-zinc-500">
        {skip + 1}–{Math.min(skip + limit, total)} di {total}
      </p>
      <div className="flex items-center gap-1">
        <Button variant="outline" size="sm" className="h-8 w-8 p-0 rounded-sm"
          disabled={currentPage <= 1}
          onClick={() => onPageChange((currentPage - 2) * limit)}
          data-testid="pagination-prev">
          <ChevronLeft className="w-4 h-4" />
        </Button>
        {Array.from({ length: Math.min(totalPages, 5) }, (_, i) => {
          let page;
          if (totalPages <= 5) {
            page = i + 1;
          } else if (currentPage <= 3) {
            page = i + 1;
          } else if (currentPage >= totalPages - 2) {
            page = totalPages - 4 + i;
          } else {
            page = currentPage - 2 + i;
          }
          return (
            <Button key={page} variant={page === currentPage ? "default" : "outline"}
              size="sm" className={`h-8 w-8 p-0 rounded-sm text-xs ${page === currentPage ? "bg-[#002FA7]" : ""}`}
              onClick={() => onPageChange((page - 1) * limit)}
              data-testid={`pagination-page-${page}`}>
              {page}
            </Button>
          );
        })}
        <Button variant="outline" size="sm" className="h-8 w-8 p-0 rounded-sm"
          disabled={currentPage >= totalPages}
          onClick={() => onPageChange(currentPage * limit)}
          data-testid="pagination-next">
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
}
